import {ArrowLeftCircleIcon, ArrowRightCircleIcon, XCircleIcon} from '@heroicons/react/24/outline'
import classNames from 'classnames'
import {useVideoModal} from './VideoModalContext'
import {gridColumnVariants} from '../util/constants'

export default function Grid({ grid, setGrid, displayActions = false, ref = null }) {
  const {setItem} = useVideoModal()

  const clearCell = (index) => {
    setGrid(grid.map((c, i) => {
      if (i === index) {
        return null
      }

      return c
    }))
  }

  const moveCellLeft = (index) => {
    if (index === 0) {
      console.error('First cell can noy be moved further left!')
      return
    }

    changeCellPosition(index, -1)
  }

  const moveCellRight = (index) => {
    if (index === grid.length - 1) {
      console.error('Last cell can noy be moved further right!')
      return
    }

    changeCellPosition(index, 1)
  }

  const changeCellPosition = (index, step) => {
    setGrid(
      grid.map((c, i) => {
        if (i === index) {
          return grid[index + step]
        } else if (i === index + step) {
          return grid[index]
        } else {
          return c
        }
      })
    )
  }

  return (
    <>
      <div ref={ref} className={`token-grid token-grid-${grid.length} grid gap-2 ${gridColumnVariants[grid.length]}`}>
        {grid.map((item, index) => (
          <div className="token-grid-item border border-dashed p-4 rounded bg-white shadow hover:shadow/30"
               key={index}>
            {!item && (
              <div className="token-grid-item__empty w-full h-full flex items-center justify-center">
                <span className="text-gray-400 text-center">{Drupal.t('No content')}</span>
              </div>
            )}
            {item && (
              <div className="token-grid-item__body w-full h-full flex flex-col">
                {item.illustration && (
                  <div className="token-grid-item__illustration grow flex items-center justify-center">
                    <img src={item.illustration.src} alt=""
                         className="max-w-full h-auto cursor-pointer"
                         onClick={() => setItem(item)} />
                  </div>
                )}
                {item.title && (
                  <div className="token-grid-item__title">
                    <div className="font-semibold text-center">{ item.title }</div>
                  </div>
                )}
                {displayActions && (
                  <div className="token-grid-item__controls grid grid-cols-3 gap-4 place-items-center mt-2 max-w-20 mx-auto">
                    {index !== 0 && (
                      <button className="cursor-pointer" title={Drupal.t('Move left')}
                              onClick={() => moveCellLeft(index)}>
                        <ArrowLeftCircleIcon className="size-5" />
                      </button>
                    )}
                    <button className={classNames('cursor-pointer', {
                      'col-start-2': index === 0,
                      'col-end-3': index === grid.length - 1
                    })} title={Drupal.t('Remove')} onClick={() => clearCell(index)}>
                      <XCircleIcon className="size-5 text-red-500" />
                    </button>
                    {index !== grid.length - 1 && (
                      <button className="cursor-pointer" title={Drupal.t('Move right')}
                              onClick={() => moveCellRight(index)}>
                        <ArrowRightCircleIcon className="size-5" />
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  )
}
